export default "__VITE_ASSET__dfe27320__"